import DriverShiftsListContainer from "../../../components/driver-shifts/DriverShiftsList";

export default function DriverShifts() {
  return <DriverShiftsListContainer />;
}
